import { createIcon } from '@chakra-ui/react';

export const Envelope = createIcon({
  displayName: 'Envelope',
  viewBox: '0 0 24 24',
  path: (
    <g id="Icon" transform="translate(-57 -709)">
      <rect
        id="Icon_Space"
        data-name="Icon Space"
        transform="translate(57 709)"
        fill="none"
      />
      <g
        id="Envelope_Letter_Email_-_L"
        data-name="Envelope Letter Email - L"
        transform="translate(57 712.464)"
      >
        <path
          id="Envelope_Letter_Email_-_L-2"
          data-name="Envelope Letter Email - L"
          d="M24.408,10.2v-.038a.584.584,0,0,0-.114-.273l-.023-.027a.512.512,0,0,0-.106-.095h0a.478.478,0,0,0-.125-.061h-.034a.6.6,0,0,0-.163-.038H1.1a.6.6,0,0,0-.148.023H.918a.478.478,0,0,0-.125.061h0a.512.512,0,0,0-.106.095l-.023.027a.584.584,0,0,0-.114.273s0,.023,0,.038V26.034a.565.565,0,0,0,.55.565H23.844a.565.565,0,0,0,.565-.565V10.2Zm-1.914.6-7.706,7.794a3.237,3.237,0,0,1-2.316.97h0a3.245,3.245,0,0,1-2.324-.97L2.445,10.8Zm.788,13.855L17.8,19.1a.565.565,0,1,0-.8.792l5.5,5.576H2.442l5.508-5.58a.565.565,0,0,0-.785-.792l-5.5,5.557V11.611l7.68,7.775a4.371,4.371,0,0,0,3.131,1.308h0a4.363,4.363,0,0,0,3.124-1.3l7.687-7.778Z"
          transform="translate(-0.55 -9.67)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
